import styled from '@emotion/styled';
import { ButtonProps, DefaultButtonCss } from '@components/atoms/Inputs/Button/Primary';

const Sub1Button = styled.button`
  ${DefaultButtonCss};
  background: #fff;
  width: 326px;
  height: 48px;
  border-width: 1px;
  border-style: solid;
  border-radius: 48px;
  font-size: 18px;
  border-color: #999;
  color: #999;
  outline: none;

  &:hover {
    background: #f5f5f5;
  }
  &:active {
    background: #999;
    color: #ffffff;
  }
  &:disabled {
    cursor: not-allowed;
    border-color: rgba(153, 153, 153, 0.3);
    color: rgba(153, 153, 153, 0.3);
    &:hover,
    :active {
      background: #fff;
    }
  }
  ${(props: ButtonProps) => props.styles};
`;

export default Sub1Button;
